import SheetContent, {
  sheetContentVariants,
  type SheetContentProps,
} from "./SheetContent";
import SheetDescription from "./SheetDescription";
import SheetHeader from "./SheetHeader";
import SheetTitle from "./SheetTitle";
import SheetFooter from "./SheetFooter";
import SheetBody from "./SheetBody";
import SheetOverlay from "./SheetOverlay";
import { Root, Trigger, Portal, Close } from "@radix-ui/react-dialog";

export {
  Root as Sheet,
  Trigger as SheetTrigger,
  Portal as SheetPortal,
  Close as SheetClose,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetFooter,
  SheetBody,
  SheetOverlay,
  sheetContentVariants,
};
export type { SheetContentProps };
